import { Box, Heading, Text } from '@eneco/sparky';

export const SelfservicePageTitle = ({ title, subtitle }: { title?: string; subtitle?: string }) => {
  if (!title) {
    return null;
  }

  return (
    <Box
      paddingLeft={{ initial: '2', sm: '0' }}
      paddingTop={{ initial: '10', md: '16' }}
      paddingBottom={{ initial: '8', md: '12' }}>
      <Heading as="h1" size={{ initial: 'S', sm: 'M', lg: 'L' }}>
        {title}
      </Heading>
      {subtitle && (
        <Box paddingTop={6}>
          <Text>{subtitle}</Text>
        </Box>
      )}
    </Box>
  );
};
